import React, { useState } from 'react'
import { Route } from 'react-router-dom';
//import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';

import * as ROUTES from '../../constants/routes';

import PropTypes from 'prop-types';
import AppBar from '@material-ui/core/AppBar';
import CssBaseline from '@material-ui/core/CssBaseline';
import IconButton from '@material-ui/core/IconButton';
import MenuIcon from '@material-ui/icons/Menu';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core/styles';
import Homepage from './Homepage';
import ResourceCentre from '../ResourceCenter';
import SidebarNav from './SidebarNav'
import './style.css'
// import Announcements from './Announcements'
// import logo from '../../../build/images/fav_logo_180.png'
// import './style.css'
// import logo from '../../fav_logo_180.png'
// import BuildWithAI from './BuildWithAI'
// import Grid from '@material-ui/core/Grid'
// import AccordionComponent from './AccordionComponent'
// import CircularProgressWithLabel from './CircularProgressWithLabel'
// import Container from '@material-ui/core/Container';
// import Divider from '@material-ui/core/Divider';
// import InboxIcon from '@material-ui/icons/MoveToInbox';
// import ListItemIcon from '@material-ui/core/ListItemIcon';
// import MailIcon from '@material-ui/icons/Mail';
// import PersonIcon from '@material-ui/icons/Person';
// import { SecondaryData } from '../../constants/SidebarData'

const drawerWidth = 240;

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
  },

  drawer: {
    [theme.breakpoints.up('sm')]: {
      width: drawerWidth,
      flexShrink: 0,
      backgroundColor: 'red'
    },
  },
  appBar: {
    [theme.breakpoints.up('sm')]: {
      width: `calc(100% - ${drawerWidth}px)`,
      marginLeft: drawerWidth,
    },
  },
  menuButton: {
    marginRight: theme.spacing(2),
    [theme.breakpoints.up('sm')]: {
      display: 'none',
    },
  },

  // necessary for content to be below app bar
  //toolbar: theme.mixins.toolbar,
  toolbar: {
    minHeight: 112,
    [`${theme.breakpoints.up('xs')} and (orientation: landscape)`]: {
      minHeight: 96,
    },
    [theme.breakpoints.up('sm')]: {
      minHeight: 128,
    },
  },
  drawerPaper: {
    width: drawerWidth,
  },
  content: {
    flexGrow: 1,
    padding: theme.spacing(3)
  }
}));

// const navStyles = {
//   // color: '#c1b8bc',
//   color: '#FFFFFF'
// }


const DashboardLayout = (props) => {
  const classes = useStyles();
  
  const [mobileOpen, setMobileOpen] = useState(false);

  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  return (
    <div className={classes.root}>
      <CssBaseline />
      <AppBar style={{backgroundColor: 'white'}} position="fixed" className={classes.appBar}>
        <Toolbar>
          <IconButton
            color="inherit"
            aria-label="open drawer"
            edge="start"
            onClick={handleDrawerToggle}
            className={classes.menuButton}
          >
            <MenuIcon style={{color: 'black'}}/>
          </IconButton>
          <Typography style={{color: 'black', fontWeight: 'bolder'}} variant="h6" noWrap>
            Hackerspace
          </Typography>
        </Toolbar>
      </AppBar>
      <SidebarNav mobileOpen={mobileOpen} classes={classes} handleDrawerToggle={handleDrawerToggle} />
      <main className={classes.content}>
        <div className={classes.toolbar} />
          
          <Route path={ROUTES.USER_DASHBOARD} component={Homepage}/>
          <Route path={ROUTES.RESOURCE_CENTER} component={ResourceCentre} />
      </main>
    </div>
  );
}

DashboardLayout.propTypes = {
  window: PropTypes.func,
};

export default DashboardLayout;
      
